import moment from "moment";
import dateUtil from "../utils/dateUtil";

/**
 * @typedef {{lang: "fr"|"en", currentDate: moment.Moment, latestUpdateISQ: moment.Moment, latestUpdateStatCan: moment.Moment}} UpdateNoticeProps
 */

/**
 * @typedef {Object} NoticeData
 * @property {string} date Date d'activation de la notice (YYYY-MM-DD).
 * @property {React.ComponentType<UpdateNoticeProps>|null} Content Contenu à afficher.
 */

/** @type {NoticeData[]} */
const noticesData = [
  {
    date: "2026-07-21",
    Content: NoticeContent20260721,
  },
  { date: "2026-06-23", Content: NoticeContent20260623 },
];

/**
 * Contenu de l'avis de mise à jour à partir du 2026-07-21
 * @param {UpdateNoticeProps} props
 */
function NoticeContent20260721({ lang, latestUpdateISQ, latestUpdateStatCan }) {
  const isqDate = dateUtil.dateToString(latestUpdateISQ, lang, "LL");
  const statCanDate = dateUtil.dateToString(latestUpdateStatCan, lang, "LL");
  // 2 mois précédant la mise à jour StatCan
  const refMonth = latestUpdateStatCan
    .clone()
    .subtract(2, "months")
    .locale(lang)
    .format("MMMM YYYY");

  return lang === "en" ? (
    <div className="cadre-vert">
      <h2>Important notice about the {isqDate} release</h2>
      <p>
        Due to the implementation of the Canada Border Services Agency (CBSA)
        Assessment and Revenue Management (CARM) system on October 21, 2024,
        delays are observed in the receipt of import data for the most recent
        reference months. These delays are impacting the quality and
        completeness of merchandise import statistics for this period. Although
        import data are published, they remain incomplete and are likely to be
        revised in the coming months.
      </p>
      <p>
        For more information, see Statistics Canada’s{" "}
        <a
          href={`https://www.statcan.gc.ca/en/statistical-programs/document/2201_D17_V2`}
          target="_blank"
          className="lien-externe"
        >
          Notes on the monthly release of Canadian international merchandise
          trade
        </a>
        .
      </p>
      <p>
        For the reference month of {refMonth}, corrections were made only to
        estimates for certain products for which the late receipt of data had
        significant impacts. However, due to technical constraints, these
        corrections could not be applied to non-seasonally adjusted data in
        current dollars. As a result, totals may differ from those presented on
        the ISQ’s website.For the reference month of March 2026, corrections
        were made only to estimates for certain products for which the late
        receipt of data had significant impacts. However, due to technical
        constraints, these corrections could not be applied to non-seasonally
        adjusted data in current dollars. As a result, totals may differ from
        those presented on the ISQ’s website.
      </p>
    </div>
  ) : (
    <div className="cadre-vert">
      <h2 className="mt-0">
        Avis important concernant la diffusion du {isqDate}
      </h2>
      <p>
        En raison de la mise en œuvre, le 21 octobre 2024, du système de Gestion
        des cotisations et des recettes (GCRA) de l’Agence des services
        frontaliers du Canada (ASFC), des retards sont observés dans la
        réception des données sur les importations pour les mois de référence
        les plus récents. Cette situation affecte la qualité et le caractère
        exhaustif des statistiques sur les importations de marchandises pour
        cette période. Bien que les données des importations soient publiées, il
        faut s’attendre à ce qu’elles soient révisées au cours des prochains
        mois.
      </p>
      <p>
        Pour obtenir plus d’information à ce sujet, consultez les{" "}
        <a
          href={`https://www.statcan.gc.ca/fr/programmes-statistiques/document/2201_D17_V2`}
          target="_blank"
          className="lien-externe"
        >
          Notes sur la diffusion mensuelle du commerce international de
          marchandises du Canada
        </a>{" "}
        de Statistique Canada.
      </p>
      <p>
        Pour le mois de référence de {refMonth}, des corrections ont été
        apportées aux estimations de seulement certains produits, pour lesquels
        les réceptions tardives de données ont eu d’importantes répercussions.
        Toutefois, en raison de contraintes techniques, ces corrections n’ont pu
        être appliquées aux données non désaisonnalisées en dollars courants.
        Par conséquent, les totaux peuvent différer de ceux présentés sur le
        site web de l’ISQ.
      </p>
    </div>
  );
}

/**
 * Contenu de l'avis de mise à jour à partir du 2026-06-23
 * @param {UpdateNoticeProps} props
 */
function NoticeContent20260623({ lang, latestUpdateISQ }) {
  const isqDate = dateUtil.dateToString(latestUpdateISQ, lang, "LL");
  /*
    const statCanDate = dateUtil.dateToString(latestUpdateStatCan, lang, "LL");
    const statCanDateFormat = latestUpdateStatCan.format("YYMMDD");
    // 2 mois précédant la mise à jour StatCan
    const refMonth = latestUpdateStatCan
      .clone()
      .subtract(2, "months")
      .locale(lang)
      .format("MMMM YYYY");
    */
  /*
    console.log("isqdate", isqDate);
    console.log("statCanDate", statCanDate);
    console.log("statCanDateFormat", statCanDateFormat);
    console.log("refMonth", refMonth);
  */
  return lang === "en" ? (
    <div className="cadre-vert">
      <h2>Important notice about the {isqDate} release</h2>
      <p>
        Due to the implementation of the Canada Border Services Agency (CBSA)
        Assessment and Revenue Management (CARM) system on October 21, 2024,
        delays are observed in the receipt of import data for the most recent
        reference months. These delays are impacting the quality and
        completeness of merchandise import statistics for this period. Although
        import data are published, they remain incomplete and are likely to be
        revised in the coming months.
      </p>
      <p>
        For more information, see Statistics Canada’s{" "}
        <a
          href={`https://www.statcan.gc.ca/en/statistical-programs/document/2201_D17_V2`}
          target="_blank"
          className="lien-externe"
        >
          Notes on the monthly release of Canadian international merchandise
          trade
        </a>
        .
      </p>
      <p>
        For the reference month of March 2026, corrections were made only to
        estimates for certain products for which the late receipt of data had
        significant impacts. However, due to technical constraints, these
        corrections could not be applied to non-seasonally adjusted data in
        current dollars. As a result, totals may differ from those presented on
        the ISQ’s website.For the reference month of March 2026, corrections
        were made only to estimates for certain products for which the late
        receipt of data had significant impacts. However, due to technical
        constraints, these corrections could not be applied to non-seasonally
        adjusted data in current dollars. As a result, totals may differ from
        those presented on the ISQ’s website.
      </p>
    </div>
  ) : (
    <div className="cadre-vert">
      <h2 className="mt-0">
        Avis important concernant la diffusion du {isqDate}
      </h2>
      <p>
        En raison de la mise en œuvre, le 21 octobre 2024, du système de Gestion
        des cotisations et des recettes (GCRA) de l’Agence des services
        frontaliers du Canada (ASFC), des retards sont observés dans la
        réception des données sur les importations pour les mois de référence
        les plus récents. Cette situation affecte la qualité et le caractère
        exhaustif des statistiques sur les importations de marchandises pour
        cette période. Bien que les données des importations soient publiées, il
        faut s’attendre à ce qu’elles soient révisées au cours des prochains
        mois.
      </p>
      <p>
        Pour obtenir plus d’information à ce sujet, consultez les{" "}
        <a
          href={`https://www.statcan.gc.ca/fr/programmes-statistiques/document/2201_D17_V2`}
          target="_blank"
          className="lien-externe"
        >
          Notes sur la diffusion mensuelle du commerce international de
          marchandises du Canada
        </a>{" "}
        de Statistique Canada.
      </p>
      <p>
        Pour le mois de référence de mars 2026, des corrections ont été
        apportées aux estimations de seulement certains produits, pour lesquels
        les réceptions tardives de données ont eu d’importantes répercussions.
        Toutefois, en raison de contraintes techniques, ces corrections n’ont pu
        être appliquées aux données non désaisonnalisées en dollars courants.
        Par conséquent, les totaux peuvent différer de ceux présentés sur le
        site web de l’ISQ.
      </p>
    </div>
  );
}

/**
 * Avis de mise à jour
 * @param {UpdateNoticeProps} props
 */
function UpdateNotice(props) {
  const { lang, currentDate, latestUpdateISQ, latestUpdateStatCan } = props;

  //Tri chronologique et recherche de la 1ère date future ou égale
  const noticeToShow = noticesData
    // On trie du plus RÉCENT au plus ANCIEN
    .sort((a, b) =>
      moment(b.date, "YYYY-MM-DD HH:mm").diff(
        moment(a.date, "YYYY-MM-DD HH:mm"),
      ),
    )
    // On cherche la 1ère notice dont la date est passée ou égale à maintenant
    .find((item) =>
      moment(item.date, "YYYY-MM-DD HH:mm").isSameOrBefore(currentDate),
    );

  return !!noticeToShow?.Content ? <noticeToShow.Content {...props} /> : null;
}

export default UpdateNotice;
